export const CACHE_KEY_MANAGER_UPDATE_QUANTITY_REQUEST = 'manager-update-quantity-request';
